















































































































import {Component, Vue, Watch} from "vue-property-decorator";
import Footer from "@/views/frame/Footer.vue";
import Header from "@/views/frame/Header.vue";


@Component({
  components: {
    Footer, Header
  },
})
export default class Customers extends Vue {
  public Index = 0
  public $refs:any = {
    carousel2:HTMLFormElement,
  }
  changeItem(e){
    this.Index = e
  }
  prev(){
    // this.Index--;
      this.$refs.carousel2.prev()
    // if(this.Index < 0){
    //     this.Index = 0
    // }
    // this.comList.forEach((ele,index)=>{
    //   if(index == this.Index){
    //     ele.isShow = true
    //   }else{
    //     ele.isShow = false
    //   }
    // })
  }
  next(){
    // this.Index++;
      this.$refs.carousel2.next()
    // if(this.Index > this.comList.length-1){
    //     this.Index = 5;
    // }
    // this.comList.forEach((ele,index)=>{
    //   if(index == this.Index){
    //     ele.isShow = true
    //   }else{
    //     ele.isShow = false
    //   }
    // })
  }
  // timer1:any;
  // mounted(){
  //   this.setTimer()
  // }
  // beforeDestroy(){
  //   this.clearTimer()
  // }
  // setTimer(){
  //   this.clearTimer();
  //   let that=this;
  //   this.timer1 = setInterval(() => {
  //     if (this.Index===5){
  //       that.Index=0;
  //       that.prev();
  //     }else{
  //       that.next();
  //     }
  //   }, 1000*10);
  // }
  // clearTimer(){
  //   clearInterval(this.timer1);
  // }
  public comList = [
    {
      imgUrl:require('../../../static/compress-img/public/customer/dahang-b.png'),
      name:'大航集团',
      content1:'为其提供了运输管理能力，帮助企业实现降本增效',
      logo:require('../../../static/compress-img/public/customer/logo-dh.png'),
      goods:'大航集团--网络货运平台',
      info:'实现TMS标准化流程，提供企业专属运力池，车货资源在线匹配，解决开票难题，税务合规',
      isShow:true,
    },
    {
      imgUrl:require('../../../static/compress-img/public/customer/wode-b.png'),
      name:'沃得集团',
      content1:'为企业供应链管理提供了数据共享和全面协同',
      logo:require('../../../static/compress-img/public/customer/logo-wd.png'),
      goods:'沃得农机--车联网物流监控平台',
      info:'实时连接30w车辆智能终端，采集运行工况数据，跟踪车辆运行轨迹，计算作业里程',
      isShow:false,
    },
    {
      imgUrl:require('../../../static/compress-img/public/customer/shengxiang-b.png'),
      name:'圣象地板',
      content1:'为其供应商管理和运输管理提供了标准流程',
      logo:require('../../../static/compress-img/public/customer/logo-sx.png'),
      goods:'圣象地板--制造企业数智物流平台',
      info:'以制造企业、承运商、收货人为主线，按照标准流程开展物流活动，实时告知物流动态',
      isShow:false,
    },
    {
      imgUrl:require('../../../static/compress-img/public/customer/yidun-b.png'),
      name:'伊顿母线',
      content1:'为其提升了运输管理能力，帮助企业实现降本增效',
      logo:require('../../../static/compress-img/public/customer/logo-yd.png'),
      goods:'伊顿母线--制造企业数智物流平台',
      info:'以制造企业、承运商、收货人为主线，按照标准流程开展物流活动，实时告知物流动态',
      isShow:false,
    },
    {
      imgUrl:require('../../../static/compress-img/public/customer/nuode-b.png'),
      name:'诺得科技',
      content1:'为其提升了运输管理能力，帮助企业实现降本增效',
      logo:require('../../../static/compress-img/public/customer/logo-nd.png'),
      goods:'诺得科技--智慧物流服务平台',
      info:'一站式物流服务，连通供应链的各个作业环节和关联主体，实现产业链资源快速整合',
      isShow:false,
    },
    {
      imgUrl:require('../../../static/compress-img/public/customer/renyi-b.png'),
      name:'仁义多式联运',
      content1:'为其提升了运输管理能力，帮助企业实现降本增效',
      logo:require('../../../static/compress-img/public/customer/logo-ry.png'),
      goods:'多式联运系统',
      info:'集公铁联运、公海联运、海铁联运等多种运输方式的解决方案，提供标准运输管理流程',
      isShow:false,
    },
  ]
  public companyList=[
    {
      imgUrl:require('../../../static/compress-img/public/customer/dahang-s.png'),
      name:'大航集团',
      content:'以货主-物流企业-司机为主线，满足TMS运输管理能力，实现在线接单、运力调度、运输执行、运费结算的标准化流程，在途跟踪车货，并为企业提供专属的运力池，实现车货资源在线匹配。解决个体司机无法给企业开票难题，合规企业的税务，帮助企业进一步实现降本增效。'
    },
    {
      imgUrl:require('../../../static/compress-img/public/customer/wode-s.png'),
      name:'沃得集团',
      content:'本项目为企业打造供应链管理平台，实现了供应链的数据共享、各主体实时在线、全面协同作业。其中车联网平台实时连接30w车辆智能终端，采集运行工况数据，跟踪车辆运行轨迹，计算作业里程。'
    },
    {
      imgUrl:require('../../../static/compress-img/public/customer/shengxiang-s.png'),
      name:'圣象地板',
      content:'企业在线管理供应商、下达发货计划、跟踪运输过程。以制造企业、承运商和收货人为主线，物流公司在线接单并开展运输活动，收货方进行签收。物流公司按照标准流程开展物流动，物流动态实时回传和告知至上下游用户，货主方和收货人可实时查看订单状态并监控运输安全。'
    },
    {
      imgUrl:require('../../../static/compress-img/public/customer/yidun-s.png'),
      name:'伊顿母线',
      content:'本项目为伊顿母线提供的智慧物流系统，帮助企业实现物流供应商管理、运输计划预测、运输方案推荐、运价预测、发运定位跟踪、异常预警电子回单等能力，提高物流计划性，提升物流交付效率，降低运输成本。'
    },
    {
      imgUrl:require('../../../static/compress-img/public/customer/nuode-s.png'),
      name:'诺得科技',
      content:'智慧物流服务平台打造一站式物流服务，连通制造企业供应链的各个作业环节和关联主体，实现生产/销售订单一键转运，运力快速响应，产业链资源快速整合。平台以国家标识码为载体，支撑业务数据全面上码，实时订单溯源，实现业务流、信息流、资金流、票据流、货物轨迹流五流合一，打造全面的供应链协同服务能力。'
    },
    {
      imgUrl:require('../../../static/compress-img/public/customer/renyi-s.png'),
      name:'仁义多式联运',
      content:'本项目集成公铁联运、公海联运、海铁联运等多种运输方式，规范多式联运作业标准，提供配套的客户管理、订单管理、结算管理等功能，多方数据互联互通，实时查看货运信息，包括运输路由、船期动态、运输情况、通关状况、运输费用等，实现全流程电子化作业、各环节实时追踪。'
    },
  ]
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/public/Customers.vue